import { useCallback } from "react"
import { Primitive } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { exists } from "shared/lib/exists"

export function useValueFormatter() {
  const { t } = useTranslation()

  return useCallback(
    (value: Primitive | null | undefined) => {
      if (typeof value === "boolean") {
        return value ? t(`Boolean.true`) : t(`Boolean.false`)
      }
      if (!exists(value)) {
        return ""
      }

      return value?.toString()
    },
    [t]
  )
}
